import { Link } from 'react-router-dom';
import { useFadeIn } from '@/hooks/useFadeIn';
import { services } from '@/mocks/homeData';

function ServiceCard({ service, index }: { service: typeof services[0]; index: number }) {
  const { ref, isVisible } = useFadeIn(0.1);
  return (
    <Link
      ref={ref}
      key={service.id}
      to={service.slug}
      className={`group bg-background-50 rounded-xl overflow-hidden card-hover fade-section ${isVisible ? 'is-visible' : ''}`}
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="relative overflow-hidden h-48 img-zoom">
        <img
          src={service.image}
          alt={service.title}
          className={`w-full h-full object-cover ${service.imagePosition || 'object-center'}`}
        />
        <div className="absolute top-3 left-3 w-10 h-10 flex items-center justify-center bg-background-50/90 rounded-lg">
          <i className={`${service.icon} text-accent-600 text-lg`}></i>
        </div>
        {service.featured && (
          <span className="absolute top-3 right-3 bg-primary-500 text-white text-[10px] font-semibold px-2.5 py-1 rounded-full">
            Destaque
          </span>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-300">
          {service.title}
        </h3>
        <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-3">
          {service.shortDescription}
        </p>
        <span className="inline-flex items-center gap-1 text-xs font-semibold text-accent-600 group-hover:gap-2 transition-all duration-300">
          Saiba mais
          <i className="ri-arrow-right-line"></i>
        </span>
      </div>
    </Link>
  );
}

export default function ServicesSection() {
  const { ref: headerRef, isVisible: headerVisible } = useFadeIn(0.15);

  return (
    <section id="servicos" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div
          ref={headerRef}
          className={`flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 fade-section ${headerVisible ? 'is-visible' : ''}`}
        >
          <div className="max-w-xl">
            <span className="text-xs uppercase tracking-[0.2em] text-accent-600 font-semibold mb-3 block">
              Nossos Tratamentos
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              Especialidades que transformam sorrisos
            </h2>
          </div>
          <p className="text-foreground-500 text-sm leading-relaxed max-w-md">
            Da prevenção à reabilitação oral completa, cada tratamento é planejado de forma personalizada com as técnicas mais avançadas da odontologia moderna.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((service, index) => (
            <ServiceCard key={service.id} service={service} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}